import { router } from "@inertiajs/react"
import type { FormDataConvertible, VisitOptions } from "@inertiajs/core"

type RequestPayload = Record<string, unknown>

/**
 * Type-safe wrappers around Inertia's router methods.
 * These enforce the data shape via TypeScript generics with zero runtime overhead.
 */
export function typedPost<T extends RequestPayload>(
  url: string,
  data: T,
  options?: Omit<VisitOptions, "method" | "data">,
): void {
  router.post(url, data as Record<string, FormDataConvertible>, options)
}

export function typedPatch<T extends RequestPayload>(
  url: string,
  data: T,
  options?: Omit<VisitOptions, "method" | "data">,
): void {
  router.patch(url, data as Record<string, FormDataConvertible>, options)
}

export function typedDelete<T extends RequestPayload>(
  url: string,
  data: T,
  options?: Omit<VisitOptions, "method" | "data">,
): void {
  router.delete(url, {
    ...options,
    data: data as Record<string, FormDataConvertible>,
  })
}
